import SquareButtonText from "ae-base/Base/SquareButtonText";
import Style from "ae-style";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { View } from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import ErrorMessage from "./Layout/ErrorMessage";
import InputContainer from "./Layout/InputContainer";
import InputLabel from "./Layout/InputLabel";
import inputStyle from "./Layout/intputStyle";

var styles = ResponsiveStylesheet.createSized("min-width", {
	0: {
		container: {
			alignItems: "center",
			justifyContent: "center",
			width: "100%"
		},
		button: {
			marginHorizontal: 5,
			borderRadius: 5,
			width: "100%",
			paddingVertical: 20,
			height: "auto"
		},
		spacing: {
			marginHorizontal: 8
		}
	},
	512: {
		container: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "center",
			flexGrow: 1,
			width: "100%"
		},
		button: {
			marginHorizontal: 5,
			borderRadius: 5,
			width: "50%"
		},
		buttonFill: {
			width: "100%"
		},
		spacing: {
			marginHorizontal: 8
		},
		buttonContainer: {
			alignItems: "center"
		}
	}
});

export default class Buttons extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accepted: (this.props.defaultValue || "") === "yes",
			denied: (this.props.defaultValue || "") === "no",
			hasChanged: false,
			newValue: null,
			buttonLeftWidth: 0,
			buttonRightWidth: 0
		};

		this.handleChangeAccept = handleChange.bind(this, "accept");
		this.handleChangeDeny = handleChange.bind(this, "deny");
	}

	componentDidUpdate(prevProps) {
		const oldDefaultValue = prevProps.defaultValue;
		const currentDefaultValue = this.props.defaultValue;

		if (currentDefaultValue !== oldDefaultValue && !this.state.hasChanged) {
			if (currentDefaultValue === "yes") {
				this.handleChangeAccept();
			} else if (currentDefaultValue === "no") {
				this.handleChangeDeny();
			}
		}
	}

	render() {
		var localize = this.context.localize;
		var localizeFrom = this.context.localizeFrom;
		var schema = this.props.schema;
		var defaultValue = this.props.defaultValue;
		var newValue = this.state.newValue;
		var errors = this.props.errors;
		var hasChanged = this.state.hasChanged;
		var displayValue = hasChanged ? newValue : defaultValue;
		var onDescription, offDescription, valueDescriptionKey;
		var onAccept = this.handleChangeAccept;
		var onDeny = this.handleChangeDeny;

		var decisionAccept = this.state.accepted
			? {
					color: "white",
					backgroundColor: Style.colors.primary
			  }
			: null;
		var decisionDeny = this.state.denied
			? {
					color: "white",
					backgroundColor: Style.colors.alert
			  }
			: null;

		var valueLocalization = schema.valueLocalization || schema.value_localization;

		if (valueLocalization) {
			onDescription = localizeFrom(valueLocalization, "yes");
			offDescription = localizeFrom(valueLocalization, "no");
		} else if (schema.value_description) {
			valueDescriptionKey = schema.value_description;
		} else {
			valueDescriptionKey = "form.switch";
		}

		if (valueDescriptionKey) {
			onDescription = localize(valueDescriptionKey + ".yes");
			offDescription = localize(valueDescriptionKey + ".no");
		}

		var directionStyle = displayValue ? styles.true : styles.false;
		var checkStyle = [inputStyle.container, styles.checkbox, directionStyle];

		if (errors && errors.length) checkStyle.push(inputStyle.errored);

		var buttonAccept = this.state.accepted ? [styles.button].concat(decisionAccept) : [styles.button];

		var buttonDeny = this.state.denied ? [styles.button].concat(decisionDeny) : [styles.button];

		var textStyleAccept = this.state.accepted
			? {
					color: "white"
			  }
			: null;

		var textStyleDeny = this.state.denied
			? {
					color: "white"
			  }
			: null;

		return (
			<InputContainer inline={this.props.inline}>
				<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
				<InputLabel schema={schema} />
				<View style={styles.buttonContainer}>
					<View style={styles.container}>
						<SquareButtonText
							id={this.props.id + "_accept"}
							title={onDescription}
							onPress={onAccept}
							style={buttonAccept}
							textStyle={textStyleAccept}
							textSize={Style.text.emphasized}
							border
						/>
						<SquareButtonText
							id={this.props.id + "_deny"}
							title={offDescription}
							onPress={onDeny}
							style={buttonDeny}
							textStyle={textStyleDeny}
							textSize={Style.text.emphasized}
							border
						/>
					</View>
				</View>
			</InputContainer>
		);
	}
}

import types from "./Layout/inputTypes";

Buttons.propTypes = types;

Buttons.contextTypes = {
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};

function handleChange(press) {
	if (press === "accept") {
		var updateValue = "yes";
		this.setState({
			accepted: true,
			denied: false,
			hasChanged: true,
			newValue: updateValue
		});
	}
	if (press === "deny") {
		updateValue = "no";
		this.setState({
			accepted: false,
			denied: true,
			hasChanged: true,
			newValue: updateValue
		});
	}
	var onChange = this.props.onChange;
	if (onChange) onChange(updateValue);
}
